import { DateTime } from 'luxon'

/*
  Agrupamento por dia das listas do Cutilei Pay — o extrato e os recebíveis.

  Saiu do `Statement` quando a segunda lista precisou do mesmo recorte. As duas mostram
  dinheiro em ordem de data, e é a data que serve de cabeçalho: sem ela, uma lista longa vira
  uma parede de valores sem referência de quando.

  Qual data vale é decisão de quem chama, e muda por lista: o extrato usa quando o dinheiro se
  moveu, e os recebíveis a data do atendimento — que é como o salão pensa o próprio
  faturamento, e não quando a transferência cai.
*/

/**
 * Quebra uma lista já ordenada em grupos de mesma data.
 *
 * Depende da ordem de entrada de propósito: a API já devolve ordenado, e reordenar aqui
 * esconderia uma mudança de `orderBy` no servidor em vez de deixá-la aparecer na tela.
 *
 * @param items - As linhas, na ordem em que vão aparecer.
 * @param getDate - Recebe uma linha e devolve o `DateTime` que a agrupa.
 * @returns `[{ key, date, items }]`, na mesma ordem da entrada.
 */
export const groupByDate = (items, getDate) => {
  const groups = []

  items.forEach (item => {
    const date = getDate (item)
    const key = date?.isValid ? date.toISODate () : 'sem-data'
    const last = groups[groups.length - 1]

    if (last && last.key === key) last.items.push (item)
    else groups.push ({key, date, items: [item]})
  })

  return groups
}

/*
  "Hoje" e "Ontem" por extenso, e a data cheia a partir daí. Ler "23 de setembro de 2026" para
  o que aconteceu há uma hora obriga quem olha a fazer a conta.
*/
export const formatGroupDate = date => {
  if (!date?.isValid) return 'Sem data'

  const today = DateTime.now ().startOf ('day')
  const days = today.diff (date.startOf ('day'), 'days').days

  if (days === 0) return 'Hoje'
  if (days === 1) return 'Ontem'

  return date.setLocale ('pt-BR').toFormat ("d 'de' LLLL 'de' yyyy")
}
